import { parsePadding } from "plano";
import { D3Utils } from "../../../utils/D3Utils";
import { MathUtils } from "../../../utils/MathUtils";
import Globals from "../../globals";
import { Component } from "./Component";

const d3 = require("d3");

export class Shelf extends Component {
    // Should be synchronous
    // and moved into the constructor
    /** @deprecated */
    static async create(data, parent) {
        let component = new Shelf(data, parent);

        let cmp = await component._init(data);
        cmp._initShelf();
        return cmp;
    }

    static async createEditor(data, parentElt) {
        let component = new Shelf(data, null, true);
        component.type = Component.TYPE_SHELF;

        let elt = await component._loadSvg(component.data.src);
        elt.id = "editor_" + data.UUID;
        component.elt = elt;
        component.eltD3 = d3.select(elt);
        parentElt.append(elt);
        component._initShelfEditor();
        return component;
    }

    async _init(data) {
        this.data.config.padding = parsePadding(data.config.padding || {});
        this.data.padding = this.data.config.padding;

        this.type = Component.TYPE_SHELF;
        return await super._init(data);
    }

    _initShelfEditor() {
        let { text } = this.data;
        if (text) {
            this.setText(text);
        }
        return this;
    }

    changeParent(newParent) {
        // shelves that change parent are always within a group and we must move it too
        const group = this.parent;
        console.assert(group.type === Component.TYPE_GROUP);
        const owner = group.parent;

        owner.children = owner.children.filter(child => child !== group);
        owner.elt.removeChild(group.elt);

        newParent.elt.appendChild(group.elt);
        newParent.children = [...newParent.children, group];

        group.setParent(newParent);
    }

    _initShelf() {
        let { posHookX, posHookY, text } = this.data;
        let positions = [];
        posHookX.forEach(x => {
            posHookY.forEach(y => positions.push({ x, y }));
        });
        if (text) {
            this.setText(text);
        }
        return this;
    }

    canSnap(pos) {
        // TODO: shelves seems to collide with the Caddy
        // return true;
        let condition = super.canSnap(pos);
        if (condition) {
            let dim = this.getDimension(pos);
            let cmpsNotGroup = this.getComponentsOutOfGroup();
            let dimComp;
            let cmpsCollision = cmpsNotGroup.filter(cmp => {
                dimComp = cmp.getDimension();
                return Component.conditionDimension(dim, dimComp);
            });

            if (cmpsCollision.length > 0) condition = false;
            if (condition) {
                let components = this.getAllComponentsChildren();
                let component, dimComponent;
                let posComponents = {};
                let posComponent = pos;
                posComponents[this.data.UUID] = posComponent;
                let uuidParent;

                components.forEach(cmp => {
                    uuidParent = cmp.getParent().data.UUID;
                    posComponents[cmp.data.UUID] = cmp.getPositionFromParent(posComponents[uuidParent]);
                });

                for (let i = 0, l = components.length; i < l; i++) {
                    if (condition) {
                        component = components[i];
                        posComponent = posComponents[component.data.UUID];
                        dimComponent = component.getDimension(posComponent);
                        if (!Component.conditionOutInner(dimComponent)) {
                            condition = false;
                        } else {
                            cmpsCollision = cmpsNotGroup.filter(cmp => {
                                dimComp = cmp.getDimension();
                                return Component.conditionDimension(dimComponent, dimComp);
                            });
                            condition = cmpsCollision.length === 0;
                        }
                    } else {
                        break;
                    }
                }
            }
        }
        return condition;
    }

    getDimension(pos = null) {
        let data = this.data;
        // console.log(data, 'data shelf')
        let { width, height, x, y, posModY, hookInverse } = data;
        x = MathUtils.convertFloat(pos ? pos.x : x, 1);
        y = MathUtils.convertFloat(pos ? pos.y : y, 1);
        width = MathUtils.convertFloat(width, 1);
        height = MathUtils.convertFloat(height, 1);

        let xEnd = x + width;
        let yEnd = y + height;

        if (!hookInverse) {
            y = y + MathUtils.convertFloat(posModY);
        }

        if (hookInverse) {
            yEnd = y + posModY;
        }

        let dimension = { x, y, xEnd, yEnd };
        return dimension;
    }

    async duplicate(group) {
        let data = Globals.assign(this.data);
        let UUID = "shelf_" + Globals.UUID();
        data.UUID = UUID;
        data.x = data.x + 50;
        let shelf = await Shelf.create(data, group);
        return shelf;
    }

    delete() {
        let group = this.getGroup();
        if (group.getComponents().length === 1) {
            group.delete();
        } else {
            super._remove();
        }
    }

    drag(start, drag, end) {
        let startDrag = this.startDrag(start);
        let endDrag = this.endDrag(end);
        D3Utils.drag(this.getGroup().eltD3, startDrag, drag, endDrag);
    }

    setText(text) {
        if (text.length <= 50) {
            this.data.text = text;
            let g = this.eltD3.select("g#TEXTS");
            let bb = g
                .select("rect")
                .raise()
                .node()
                .getBBox();
            let fontSize = bb.height / 2;
            g.select("text.text-shelf").remove();
            g.append("text")
                .raise()
                .attr("class", "text-shelf")
                .attr("x", bb.x + bb.width / 2)
                .attr("y", bb.y + bb.height)
                .attr("font-size", fontSize)
                .style("font-size", fontSize)
                .attr("alignment-baseline", "ideographic")
                .attr("text-anchor", "middle")
                .text(text);
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/plano/components/Shelf.js